import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import InputHarian from "@/pages/InputHarian";
import Laporan from "@/pages/Laporan";
import Riwayat from "@/pages/Riwayat";
import Cabang from "@/pages/Cabang";
import Users from "@/pages/Users";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Tagihan from "@/pages/Tagihan";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/input-harian" element={<InputHarian />} />
            <Route path="/laporan" element={<Laporan />} />
            <Route path="/riwayat" element={<Riwayat />} />
            <Route path="/tagihan" element={<Tagihan />} />
            <Route path="/bahan-baku" element={<Navigate to="/riwayat?tab=bahan_baku" replace />} />
            <Route path="/ops" element={<Navigate to="/riwayat?tab=ops" replace />} />
            <Route path="/insentif" element={<Navigate to="/riwayat?tab=insentif" replace />} />
            <Route path="/lainnya" element={<Navigate to="/riwayat?tab=lainnya" replace />} />
            <Route path="/audit" element={<AuditLog />} />
            <Route path="/cabang" element={<Cabang />} />
            <Route path="/pengguna" element={<Users />} />
            <Route path="/pengaturan" element={<Settings />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
